import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { WelltectChangePasswordSentComponent } from './welltect-change-password-sent/welltect-change-password-sent.component';
import { WelltectForgotPasswordComponent } from './welltect-forgot-password/welltect-forgot-password.component';
import { WelltectInputComponent } from './welltect-input/welltect-input.component';
import { WelltectLoginComponent } from './welltect-login/welltect-login.component';
import { WelltectOemHeaderComponent } from './welltect-oem-header/welltect-oem-header.component';
import { WelltectOemLoginMessageComponent } from './welltect-oem-login-message/welltect-oem-login-message.component';
import { WelltectOemRegisterMessageComponent } from './welltect-oem-register-message/welltect-oem-register-message.component';
import { WelltectPasswordInputComponent } from './welltect-password-input/welltect-password-input.component';
import { WelltectRegisterResendComponent } from './welltect-register-resend/welltect-register-resend.component';
import { WelltectRegisterSendComponent } from './welltect-register-send/welltect-register-send.component';
import { WelltectRegisterComponent } from './welltect-register/welltect-register.component';
import { WelltectResetPasswordComponent } from './welltect-reset-password/welltect-reset-password.component';
import { WelltectUnblockComponent } from './welltect-unblock/welltect-unblock.component';
import { WelltectComponent } from './welltect/welltect.component';

@NgModule({
  declarations: [
    WelltectComponent,
    WelltectLoginComponent,
    WelltectRegisterComponent,
    WelltectUnblockComponent,
    WelltectRegisterResendComponent,
    WelltectRegisterSendComponent,
    WelltectForgotPasswordComponent,
    WelltectResetPasswordComponent,
    WelltectChangePasswordSentComponent,
    WelltectInputComponent,
    WelltectPasswordInputComponent,
    WelltectOemHeaderComponent,
    WelltectOemRegisterMessageComponent,
    WelltectOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    WelltectResetPasswordComponent,
    WelltectComponent,
    WelltectRegisterResendComponent,
    WelltectRegisterSendComponent,
    WelltectUnblockComponent,
    WelltectChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WelltectModule {}
